import React, { useState,useEffect } from 'react';
import { BASE_URL } from '../utils/config';
import ReactSelect from 'react-select'
import Loading from './loading';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Dialog} from '@mui/material';

const OptionSection = ({ stockSymbols, IntraDaychecked, SecondTarget, requestToken, commenteryData, isEditable, onOptionSectionChange, onOptionExpirySelect, onOptionStockSelect, onRemoveFile, onStockLossRecord, generateImage }) => {
  const [optionSectionState, setOptionSectionState] = useState({
    optionReportType: 'CALL',
    stockType: '',
    optionCMP: '',
    optionSL: '0',
    strikePrice: '',
    stockIncToken: '',
    underlayingPrice: '',
    futureCMP: '',
    first_target: '',
    second_target: '',
    optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    commentry: '',
    chartImageInterval:'1D',
    Expiry: '',
    volume: '',
    openInterest: '',
    lot_size: ''
  });
  const options = stockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft: '185px'
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };
  const [SelectedStockRecord,setSelectedStockRecord]=useState({}); 
  const [expiryData, setExpiryData] = useState([]);
  const [expiryshow, setexpiryshow] = useState(false);
  const [underlayingPriceerror, setunderlayingPriceError] = useState(false)
  const [firstTargeterror, setFirstTargetError] = useState(false)
  const [secondTargeterror, setSecondTargetError] = useState(false)
  const [optioncmperror, setOptionCmpError] = useState(false)
  const [slerror, setSlError] = useState(false)
  const [volumeError, setVolumeError] = useState(false)
  const [strikePriceerror, setstrikePriceError] = useState(false)
  const [CmpErrorMsz, setCmpErrorMsz] = useState('')
  const [showCmpApiError, setShowCmpApiError] = useState(false)

  const [StrikePriceErrorMsz, setStrikePriceErrorMsz] = useState('')
  const [showStrikePriceApiError, setShowStrikePriceApiError] = useState(false)
  
  const [strikePriceData, setStrikePriceData] = useState([])
  const [optionCmpData, setOptionCmpData] = useState([])
  const [stopLossData, setStopLossData] = useState([])
  const [volumeData, setVolumeData] = useState([])
  const [loading, setLoading] = useState(false);
    const [showAlert, setshowAlert] = useState(false);
    const [AlertMessage, setAlertMessage] = useState("");
  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'



  useEffect(() => {
    const getSelectedCommentary = (type) => {
      const label = type === 'CALL' ? 'Call 1' : 'Put 1';
      console.log("label",label)
      return commenteryData.find(data => data.CommentaryName === label) || null;
    };

    const selectedData = getSelectedCommentary(optionSectionState.optionReportType);
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        commentry: selectedData?.Description || '',
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onOptionSectionChange(newState);
     
      return newState;
    });
  }, [commenteryData]);

  // handle input change for all inputs
  const handleInputChange = (event) => {
    setunderlayingPriceError(false);
    setFirstTargetError(false);
    setSecondTargetError(false);
    setOptionCmpError(false);
    setSlError(false);
    setstrikePriceError(false);
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setOptionSectionState((prevState) => {
        let newState
        if(name === 'second_target' && value.trim() === ''){
          newState = {
            ...prevState,
            [name]: null,
            
          };
        }
        else if (name === 'optionSL' && value == '0') {

          newState = {
            ...prevState,
            [name]: value,
            optionRemark: RemarkText
          };
        }
        else if (name === 'optionSL' && value != '0') {
          newState = {
            ...prevState,
            [name]: value,
            optionRemark: ""
          };
        }
        else {
          newState = {
            ...prevState,
            [name]: value,

          };
        }


        // Log the updated state
        console.log("OptionSectionState", newState);

        // Notify the parent component about the change
        onOptionSectionChange(newState);

        return newState;
      });
    }
    else {
      if (name === 'optionCMP') {
        setOptionCmpError(true)
        setTimeout(() => {
          setOptionCmpError(false)
        }, 2000);
      }
      else if (name === 'underlayingPrice') {
        setunderlayingPriceError(true)
        setTimeout(() => {
          setunderlayingPriceError(false)
        }, 2000);
      }
      else if (name === 'first_target') {
        setFirstTargetError(true)
        setTimeout(() => {
          setFirstTargetError(false)
        }, 2000);
      }
      else if (name === 'second_target') {
        setSecondTargetError(true)
        setTimeout(() => {
          setSecondTargetError(false)
        }, 2000);
      }
      else if (name === 'strikePrice') {
        setstrikePriceError(true)
        setTimeout(() => {
          setstrikePriceError(false)
        }, 2000);
      }
      else if (name === 'optionSL') {
        setSlError(true)
        setTimeout(() => {
          setSlError(false)
        }, 2000);
      }
      else if (name === 'volume') {
        setVolumeError(true)
        setTimeout(() => {
          setVolumeError(false)
        }, 2000);
      }
    }

  };



// handle change radio button call and  put
  const handleChange = (event) => {

    const { name, value } = event.target;


    if(name === 'optionReportType'){
      const getSelectedCommentary = (type) => {
        const label = type === 'CALL' ? 'Call 1' : 'Put 1';
        console.log("label",label)
        return commenteryData.find(data => data.CommentaryName === label) || null;
      };
  
      const selectedData = getSelectedCommentary(value);
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
          commentry: selectedData?.Description || '',
          stockType: '',
    optionCMP: '',
    optionSL: '0',
    strikePrice: '',
    stockIncToken: '',
    underlayingPrice: '',
    futureCMP: '',
    first_target: '',
    second_target: '',
    optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    chartImageInterval:'1D',
    Expiry: '',
    volume: '',
    openInterest: '',
    lot_size: ''
        };
  
        // Log the updated state
        console.log("OptionSectionState", newState);
  
        // Notify the parent component about the change
        onOptionSectionChange(newState);
        setStrikePriceData([]);
        setOptionCmpData([]);
        setStopLossData([]);
        setVolumeData([])
        return newState;
      });
    }else{
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onOptionSectionChange(newState);

      return newState;
    });
  }


  };

// handle change for chart interval
  const handleChartinterval = (event) => {

    const { name, value } = event.target;

     if (!optionSectionState.stockType || !optionSectionState.Expiry) {
    console.log("Stock symbol not available. Skipping interval change.");
    setAlertMessage(`Please Select Stock Name and Expiry First then try to change the Image Interaval.`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    return;
  }
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onOptionSectionChange(newState);


      generateImage(SelectedStockRecord.TV_STOCK_Symbol, SelectedStockRecord.TVExchange,value)
      return newState;
    });


    


  };

  // handle change for stock name select
  const handlechangestock = async (event) => {
    // const { name, value } = event.target;

    setLoading(true)
    let selectedStockRecord
    let type 
    if(event.value === 'SENSEX'){
     type = 'BFO-OPT';
    }else{
      type = 'NFO-OPT';
    }
    let last_price
    let Expiry_date

    const getSelectedCommentary = (type) => {
      const label = type === 'CALL' ? 'Call 1' : 'Put 1';
      console.log("label",label)
      return commenteryData.find(data => data.CommentaryName === label) || null;
    };

    const selectedData = getSelectedCommentary(optionSectionState.optionReportType);
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.value,
        optionCMP: "",
        optionSL: '0',
        strikePrice: "",
        underlayingPrice: '',
        futureCMP: '',
        first_target: '',
        second_target: '',
        optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
        commentry: selectedData?.Description || '',
        Expiry: '',
        volume: ''

      };

      // Log the updated state
      // console.log("OptionSectionState", newState);
      onRemoveFile();
    
      selectedStockRecord = stockSymbols.find(item => item.name === event.value);

      console.log("selectedStockRecord inside setoptiondata", selectedStockRecord);

      setSelectedStockRecord(selectedStockRecord);

      onOptionStockSelect(selectedStockRecord);
      onOptionSectionChange(newState);
      generateImage(selectedStockRecord.TV_STOCK_Symbol, selectedStockRecord.TVExchange,optionSectionState.chartImageInterval)

      return newState;
    });

    setStrikePriceData([]);
    setOptionCmpData([]);
    setStopLossData([]);
    setVolumeData([])


      

    console.log("selectedStockRecord outsiden setoptiondata", selectedStockRecord);

    // expiry select default index 0
    try {
      const response = await fetch(`${BASE_URL}/getstockexpiry/${event.value}/${type}`, {
      method: 'GET'
      });

      if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();
      console.log(res);

      if (res.success === true && res.data && res.data.length > 0) {
      console.log("res.data", res.data);

      let expiryData = JSON.parse(res.data[0].dates);

      console.log("expiryData", expiryData);
      if (expiryData.length > 0) {
        setExpiryData(expiryData);
        setexpiryshow(true);
      }

      Expiry_date = expiryData[0].expiry;

      setOptionSectionState((prevState) => {
        const newState = {
        ...prevState,
        Expiry: expiryData[0].expiry,
        };

        onOptionSectionChange(newState);

        return newState;
      });
      } else {
      console.error("Expiry data not found or invalid response");
      setexpiryshow(false);
      setExpiryData([]);
      setAlertMessage(`Error: ${res.message}`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 2000);
      return
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setexpiryshow(false);
      setExpiryData([]);
      setAlertMessage(`Error: ${error.message}`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 2000);
      return
    }

    let url
    if (IntraDaychecked) {
      if (event.value && Expiry_date) {
      url = `${BASE_URL}/getcmpprice/${event.value}/${'IntraDay'}/${Expiry_date}`;
      } else {
      setCmpErrorMsz(`Error: Missing required API values ( stock name, or expiry date).`)
      setShowCmpApiError(true);
     
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('')
      }, 2000);
      return
      }
    } else {
      console.log("insdie else to call api of cmp price ")
      if ( event.value && requestToken && Expiry_date) {
      url = `${BASE_URL}/getcmpprice/${event.value}/${requestToken}/${Expiry_date}`;
      } else {
        setCmpErrorMsz(`Error: Missing required API values ( stock name, or expiry date).`)
        setShowCmpApiError(true);
       
        setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('')
        }, 2000);
        return
      }
    }
    // get cmp of stock
    try {
      const response = await fetch(`${url}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
      });

      if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();
      console.log(res);

      if (res.success === true) {
      console.log("res.data for cmp price -====", res);

      if (IntraDaychecked) {
        let Stock_IncToken = res.stock_IncToken;
        let futurecmp_token = res.futurecmp_token;
        last_price = res.instruments.last_price;
        let futurecmp = res.Futurecmp?.last_price || '';

        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: last_price,
          stockIncToken: Stock_IncToken,
          futureCMP: futurecmp,
          FutureIncToken: futurecmp_token,
        };

        console.log("OptionSectionState", newState);
        onOptionSectionChange(newState);
        return newState;
        });
      } else {
        let Stock_IncToken = res.stock_IncToken;
        last_price = res.instruments.last_price;

        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: last_price,
          stockIncToken: Stock_IncToken,
        };

        console.log("OptionSectionState", newState);
        onOptionSectionChange(newState);
        return newState;
        });
      }
      } else {
        setCmpErrorMsz(`Error: ${res.message}`)
      setShowCmpApiError(true);
      setOptionSectionState((prevState) => {
        const newState = {
        ...prevState,
        optionCMP: "",
        stockIncToken: '',
        };

        console.log("OptionSectionState", newState);
        onOptionSectionChange(newState);
        return newState;
      });
      setTimeout(() => {
        setShowCmpApiError(false);
      setCmpErrorMsz('')
      }, 2000);
      return
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setCmpErrorMsz(`Error: ${error.message}`)
      setShowCmpApiError(true);
      setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        optionCMP: "",
      };

      console.log("OptionSectionState", newState);
      onOptionSectionChange(newState);
      return newState;
      });
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('')
      }, 2000);
      return
    }


    if (
      event.value !== '' &&
      Expiry_date !== '' &&
      optionSectionState.optionReportType !== '' &&
      last_price !== ''
    ) { 
      let body = JSON.stringify({ 
      stock_name: event.value,
      tvsymbol: selectedStockRecord.TV_STOCK_Symbol,
      expiry: Expiry_date, 
      optionType: optionSectionState.optionReportType, 
      cmpPrice: last_price, 
      intraDaychecked: IntraDaychecked 
      });

      await fetch(`${BASE_URL}/getstrikeprice`, {
      method: 'POST',
      body,
      headers: {
        "Content-Type": "application/json",
      },
      })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("strike prices response", res);

        if (res.success === true) {
        let record = res.data;
        let StopLossVolumeData = res.StopLossVolumeData;
        let optionData = res.optioncmpData;
        setStrikePriceData(record);
        setOptionCmpData(optionData);
        setStopLossData(StopLossVolumeData);
        setVolumeData(StopLossVolumeData);

        let tvRecord = StopLossVolumeData[0].tvRecord;
        let selectedRecord = null;
        for (let i = 0; i < tvRecord.length; i++) {
          const record = tvRecord[i];

          if (optionSectionState.optionReportType === "CALL") {
          if (selectedRecord === null || record.low < selectedRecord.low) {
            selectedRecord = record;
          }
          } else if (optionSectionState.optionReportType === "PUT") {
          if (selectedRecord === null || record.high > selectedRecord.high) {
            selectedRecord = record;
          }
          }
        }
        onOptionExpirySelect(res.data[0]);
        onStockLossRecord(selectedRecord);

        console.log("StopLossVolumeData", StopLossVolumeData[0]);
        setOptionSectionState((prevState) => {
          let newState;
          if (StopLossVolumeData[0].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            strikePrice: record[0].strike,
            underlayingPrice: optionData[0].last_price,
            first_target: optionData[0].first_target,
            second_target: optionData[0].second_target,
            lot_size: optionData[0].lot_size,
            volume: StopLossVolumeData[0].volume,
            openInterest: StopLossVolumeData[0].openInterest,
            optionSL: StopLossVolumeData[0].OptionstopLoss,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
          } else {
          newState = {
            ...prevState,
            strikePrice: record[0].strike,
            underlayingPrice: optionData[0].last_price, 
            first_target: optionData[0].first_target,
            second_target: optionData[0].second_target,
            lot_size: optionData[0].lot_size,
            volume: StopLossVolumeData[0].volume,
            openInterest: StopLossVolumeData[0].openInterest,
            optionSL: StopLossVolumeData[0].OptionstopLoss,
            optionRemark: ''
          };
          }

          onOptionSectionChange(newState);

          return newState;
        });

        setLoading(false);

        } else {
          console.log("inside else of api",res.data)
        setLoading(false);
        setStrikePriceData(res.data);
        setStrikePriceErrorMsz(`Error: ${res.message}`)
        setShowStrikePriceApiError(true);
        setOptionSectionState((prevState) => {
          const newState = {
          ...prevState,
          strikePrice: "",
          underlayingPrice: '',
          first_target: '',
          second_target: '',
          lot_size: '',
          optionSL: '0',
          volume: "",
          openInterest: "",
          optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade."
          };

          onOptionSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowStrikePriceApiError(false);
          setStrikePriceErrorMsz('')
        }, 5000);
        }

      })
      .catch(error => {
        // Handle errors
        setLoading(false);
        setStrikePriceErrorMsz(`Error: ${error.message}`)
        setShowStrikePriceApiError(true);
        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          strikePrice: "",
          underlayingPrice: '',
          first_target: '',
          second_target: '',
          optionSL: '0',
          volume: "",
          openInterest: "",
          optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
        };

        onOptionSectionChange(newState);

        return newState;
        });
        setTimeout(() => {
        setShowStrikePriceApiError(false);
        setStrikePriceErrorMsz('')
        }, 5000);
        console.error('Error fetching data:', error);
        return
      });
    } else {
      setLoading(false);
      setCmpErrorMsz("Error: Missing required API values (stock name, expiry date, report type, or CMP).");
      setShowCmpApiError(true);
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('');
      }, 2000);
    }

  };

  // handle change for expiry select
  const handlechangeExpiry = async (event) => {
    const { name, value } = event.target;

    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
        optionSL: '0',
        strikePrice: "",
        underlayingPrice: '',
        futureCMP: '',
        first_target: '',
        second_target: '',
        optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
       
        volume: ''
      };

      // Log the updated state
      // console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      // const selectedExpiryRecord = expiryData.find(item => item.expiry === value);
      // // console.log("selectedExpiryRecord",selectedExpiryRecord)
      // onOptionExpirySelect(selectedExpiryRecord);
      onOptionSectionChange(newState);

      return newState;
    });

    // onOptionSectionChange(optionSectionState);
    setStrikePriceData([]);
    setOptionCmpData([]);
    setStopLossData([]);
    setVolumeData([])
    fetchStrikePrice(value,'Expiry');
  }

  // To format the date in dd-mm-yyyy format to show in expiry select
  const formatDate = (dateString) => {
    // console.log("dateString",dateString)
    const dateObject = new Date(dateString);
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with a leading zero
    const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;

    return formattedDate;
  }

  // handle change for Commentry
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    const selectedValue = event.target.value;
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
      onOptionSectionChange(newState);

      const selectedData = commenteryData.find((data) => data.Description === selectedValue);
      console.log("selectedData", selectedData);
      
      return newState;
    });
  };

  // handle Fetch api for cmp price
  const fetchCMP = async (event) => {
    event.preventDefault();
    const StockName = optionSectionState.stockType
    console.log("StockName", StockName);
    let url
    if (!StockName || !optionSectionState.Expiry ) {
      setCmpErrorMsz("Error: Missing required API values (Stock Name, Expiry, or Request Token).");
      setShowCmpApiError(true);
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('');
      }, 2000);
      return;
    }

    if (IntraDaychecked) {
      url = `${BASE_URL}/getcmpprice/${StockName}/${'IntraDay'}/${optionSectionState.Expiry}`;
    } else {
      url = `${BASE_URL}/getcmpprice/${StockName}/${requestToken}/${optionSectionState.Expiry}`;
    }

    await fetch(`${url}`, {
      method: 'GET',
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      // Process the API response data
      console.log(res);

      if (res.success === true) {
        console.log("res.data", res.instruments);
        let last_price = res.instruments.last_price;

        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: last_price,
        };

        // Log the updated state
        console.log("OptionSectionState", newState);

        // Notify the parent component about the change
        onOptionSectionChange(newState);

        return newState;
        });

        fetchStrikePrice(last_price, 'FetchCMP');
      } else {
        setCmpErrorMsz(res.message || "Error fetching CMP price.");
        setShowCmpApiError(true);
        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          optionCMP: "",
        };

        console.log("OptionSectionState", newState);
        onOptionSectionChange(newState);

        return newState;
        });
        setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
        }, 2000);
      }
      })
      .catch(error => {
      setCmpErrorMsz(`Error: ${error.message}`);
      setShowCmpApiError(true);
      setOptionSectionState((prevState) => {
        const newState = {
        ...prevState,
        optionCMP: "",
        };

        console.log("OptionSectionState", newState);
        onOptionSectionChange(newState);

        return newState;
      });
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 2000);
      console.error('Error fetching data:', error);
      });
  }

// handle fetch api for Strike price
  const fetchStrikePrice = async (Value,type) => {

    // event.preventDefault();
    console.log("optionSectionState", optionSectionState);
    let body;
    setLoading(true);

   
    if (type === 'Expiry') {

      if (!optionSectionState.stockType || !optionSectionState.optionReportType || !Value || !optionSectionState.optionCMP || !SelectedStockRecord.TV_STOCK_Symbol) {
        setLoading(false);
        setStrikePriceErrorMsz("Error: Missing required API values (Stock Name, Option Type, Expiry, or CMP).");
        setShowStrikePriceApiError(true);
        setTimeout(() => {
        setShowStrikePriceApiError(false);
        setStrikePriceErrorMsz('');
        }, 2000);
        return;
      }
  
      body = JSON.stringify({
      stock_name: optionSectionState.stockType,
      tvsymbol: SelectedStockRecord.TV_STOCK_Symbol,
      expiry: Value,
      optionType: optionSectionState.optionReportType,
      cmpPrice: optionSectionState.optionCMP,
      intraDaychecked: IntraDaychecked
      });
    } else {

      if (!optionSectionState.stockType || !optionSectionState.optionReportType || !Value || !optionSectionState.Expiry || !SelectedStockRecord.TV_STOCK_Symbol) {
        setLoading(false);
        setStrikePriceErrorMsz("Error: Missing required API values (Stock Name, Option Type, Expiry, or CMP).");
        setShowStrikePriceApiError(true);
        setTimeout(() => {
        setShowStrikePriceApiError(false);
        setStrikePriceErrorMsz('');
        }, 2000);
        return;
      }
      body = JSON.stringify({
      stock_name: optionSectionState.stockType,
      tvsymbol: SelectedStockRecord.TV_STOCK_Symbol,
      expiry: optionSectionState.Expiry,
      optionType: optionSectionState.optionReportType,
      cmpPrice: Value,
      intraDaychecked: IntraDaychecked
      });
    }

    await fetch(`${BASE_URL}/getstrikeprice`, {
      method: 'POST',
      body,
      headers: {
      "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
      console.log("strike prices response", res);

      if (res.success === true) {
        let record = res.data;
        let StopLossVolumeData = res.StopLossVolumeData;
        let optionData = res.optioncmpData;
        setStrikePriceData(record);
        setOptionCmpData(optionData);
        setStopLossData(StopLossVolumeData);
        setVolumeData(StopLossVolumeData);

        let tvRecord = StopLossVolumeData[0].tvRecord;
        let selectedRecord = null;
        for (let i = 0; i < tvRecord.length; i++) {
        const record = tvRecord[i];
        if (optionSectionState.optionReportType === "CALL") {
          if (selectedRecord === null || record.low < selectedRecord.low) {
          selectedRecord = record;
          }
        } else if (optionSectionState.optionReportType === "PUT") {
          if (selectedRecord === null || record.high > selectedRecord.high) {
          selectedRecord = record;
          }
        }
        }
        onOptionExpirySelect(res.data[0]);
        onStockLossRecord(selectedRecord);

        setOptionSectionState((prevState) => {
        let newState;
        if (StopLossVolumeData[0].OptionstopLoss == 0) {
          newState = {
          ...prevState,
          strikePrice: record[0].strike,
          underlayingPrice: optionData[0].last_price,
          first_target: optionData[0].first_target,
          second_target: optionData[0].second_target,
          lot_size: optionData[0].lot_size,
          volume: StopLossVolumeData[0].volume,
          openInterest: StopLossVolumeData[0].openInterest,
          optionSL: StopLossVolumeData[0].OptionstopLoss,
          optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
          ...prevState,
          strikePrice: record[0].strike,
          underlayingPrice: optionData[0].last_price,
          first_target: optionData[0].first_target,
          second_target: optionData[0].second_target,
          lot_size: optionData[0].lot_size,
          volume: StopLossVolumeData[0].volume,
          openInterest: StopLossVolumeData[0].openInterest,
          optionSL: StopLossVolumeData[0].OptionstopLoss,
          optionRemark: ''
          };
        }
        onOptionSectionChange(newState);
        return newState;
        });

        setLoading(false);
      } else {
        setLoading(false);
        setStrikePriceErrorMsz(`Error: ${res.message}`);
        setShowStrikePriceApiError(true);
        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          strikePrice: "",
          underlayingPrice: '',
          first_target: "",
          second_target: "",
          lot_size: '',
          optionSL: '0',
          volume: "",
          openInterest: "",
          optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade."
        };
        onOptionSectionChange(newState);
        return newState;
        });
        setTimeout(() => {
        setShowStrikePriceApiError(false);
        setStrikePriceErrorMsz('')
        }, 1000);
      }
      })
      .catch(error => {
      setLoading(false);
      setStrikePriceErrorMsz(`Error: ${error.message}`);
      setShowStrikePriceApiError(true);
      setOptionSectionState((prevState) => {
        const newState = {
        ...prevState,
        strikePrice: "",
        underlayingPrice: '',
        first_target: "",
        second_target: "",
        optionSL: '0',
        volume: "",
        openInterest: "",
        optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
        };
        onOptionSectionChange(newState);
        return newState;
      });
      setTimeout(() => {
        setShowStrikePriceApiError(false);
        setStrikePriceErrorMsz('')
      }, 1000);
      console.error('Error fetching data:', error);
      });

  }


// handle change for strike price select
//  const handleStrikeChange = async (event) => {
//    const { name, value } = event.target;

//    const indexOfMatchingValue = strikePriceData.findIndex((data) => data.strike == value);
//    console.log(indexOfMatchingValue, "indexOfMatchingValue strike change")
//    if (indexOfMatchingValue !== -1) {
//      console.log("value")

     

   //   const lastpricePresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].last_price !== undefined;
   //   const firstTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].first_target !== undefined;
   //   const secondTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].second_target !== undefined;
   //   const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
    //  const volumePresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].volume !== undefined;
  //    const OIPresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].openInterest !== undefined;
  
//      console.log("slPresent",slPresent)
//      setOptionSectionState((prevState) => {
//        let newState
//        if (stopLossData[0].OptionstopLoss == 0) {
//          newState = {
//            ...prevState,
//            [name]: value,
     //       underlayingPrice: lastpricePresent? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
     //       first_target: firstTargetPresent ? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
     //       second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
     //       optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
     //       volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
     //       openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
     //       optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
//          };
//        } else {
//          newState = {
//            ...prevState,
//            [name]: value,
       //     underlayingPrice: lastpricePresent? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
       //     first_target: firstTargetPresent ? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
       //     second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
       //     optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
       //     volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
       //     openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
//          };
//        }



//        onOptionSectionChange(newState);

       // let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
       // let selectedRecord = null
       // for (let j = 0; j < tvRecord.length; j++) {
       //   const record = tvRecord[j];

      //    if (optionSectionState.optionReportType === "CALL") {
      //      if (selectedRecord === null || record.low < selectedRecord.low) {
      //        selectedRecord = record;
      //      }
      //    } else if (optionSectionState.optionReportType === "PUT") {
      //      if (selectedRecord === null || record.high > selectedRecord.high) {
      //        selectedRecord = record;
      //      }
      //    }
      //  }
      //  onStockLossRecord(selectedRecord);
      // onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
//        return newState;
//      });
//    } else {
//      setOptionSectionState((prevState) => {
//        const newState = {
//          ...prevState,
//          [name]: value,

//        };

  //      onOptionSectionChange(newState);

  //      return newState;
  //    });
  //  }


 // }



const handleStrikeChange = async (event) => {
    const { name, value } = event.target;

    const indexOfMatchingValue = strikePriceData.findIndex((data) => data.strike == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue strike change")
    if (indexOfMatchingValue !== -1) {
      console.log("value")

     
 const strikePresent = [strikePriceData[indexOfMatchingValue]]
  console.log("strike present",strikePresent);

         if (
      optionSectionState.stockType !== '' &&
      optionSectionState.Expiry !== '' &&
      optionSectionState.optionReportType !== '' &&
      optionSectionState.optionCMP !== '' &&
      strikePresent !== '') 
      {
      let body = JSON.stringify({ 
      stock_name: optionSectionState.stockType,
      tvsymbol: SelectedStockRecord.TV_STOCK_Symbol,
      expiry: optionSectionState.Expiry, 
      optionType: optionSectionState.optionReportType, 
      cmpPrice: optionSectionState.optionCMP, 
      strikeRecord: strikePresent,
      intraDaychecked: IntraDaychecked 

      });

      await fetch(`${BASE_URL}/getonestrikeprice`, {
      method: 'POST',
      body,
      headers: {
        "Content-Type": "application/json",
      },
      })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("strike prices response", res);

        if (res.success === true) {
        // let record = res.data;
        let StopLossVolumeData = res.StopLossVolumeData;
        let optionData = res.optioncmpData;
        // setStrikePriceData(record);
        setOptionCmpData(optionData);
        setStopLossData(StopLossVolumeData);
        setVolumeData(StopLossVolumeData);

        let tvRecord = StopLossVolumeData[0].tvRecord;
        let selectedRecord = null;
        for (let i = 0; i < tvRecord.length; i++) {
          const record = tvRecord[i];

          if (optionSectionState.optionReportType === "CALL") {
          if (selectedRecord === null || record.low < selectedRecord.low) {
            selectedRecord = record;
          }
          } else if (optionSectionState.optionReportType === "PUT") {
          if (selectedRecord === null || record.high > selectedRecord.high) {
            selectedRecord = record;
          }
          }
        }
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
        onStockLossRecord(selectedRecord);

        console.log("StopLossVolumeData", StopLossVolumeData[0]);
        setOptionSectionState((prevState) => {
          let newState;
          if (StopLossVolumeData[0].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            strikePrice: value,
            underlayingPrice: optionData[0].last_price,
            first_target: optionData[0].first_target,
            second_target: optionData[0].second_target,
            lot_size: optionData[0].lot_size,
            volume: StopLossVolumeData[0].volume,
            openInterest: StopLossVolumeData[0].openInterest,
            optionSL: StopLossVolumeData[0].OptionstopLoss,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
          } else {
          newState = {
            ...prevState,
            strikePrice: value,
            underlayingPrice: optionData[0].last_price, 
            first_target: optionData[0].first_target,
            second_target: optionData[0].second_target,
            lot_size: optionData[0].lot_size,
            volume: StopLossVolumeData[0].volume,
            openInterest: StopLossVolumeData[0].openInterest,
            optionSL: StopLossVolumeData[0].OptionstopLoss,
            optionRemark: ''
          };
          }

          onOptionSectionChange(newState);

          return newState;
        });

        setLoading(false);

        } else {
          console.log("inside else after api response of getonestrike")

        let data = res.data 
        const strikeToRemove = data[0].strike;
        console.log("strikeToRemove =",strikeToRemove)
        setLoading(false);
        setStrikePriceData(prev =>
          prev.filter(item => item.strike !== strikeToRemove)
        );
        setStrikePriceErrorMsz(`Error: ${res.message}`)
        setShowStrikePriceApiError(true);
        setOptionSectionState((prevState) => {
          const newState = {
          ...prevState,
          strikePrice: "",
          underlayingPrice: '',
          first_target: '',
          second_target: '',
          lot_size: '',
          optionSL: '0',
          volume: "",
          openInterest: "",
          optionRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade."
          };

          onOptionSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowStrikePriceApiError(false);
          setStrikePriceErrorMsz('')
        }, 1500);
        }

      })
      .catch(error => {
        // Handle errors
        setLoading(false);
        setStrikePriceErrorMsz(`Error: ${error.message}`)
        setShowStrikePriceApiError(true);
        setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          strikePrice: "",
          underlayingPrice: '',
          first_target: '',
          second_target: '',
          optionSL: '0',
          volume: "",
          openInterest: "",
          optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
        };

        onOptionSectionChange(newState);

        return newState;
        });
        setTimeout(() => {
        setShowStrikePriceApiError(false);
        setStrikePriceErrorMsz('')
        }, 1500);
        console.error('Error fetching data:', error);
        return
      });
    } else {
      setLoading(false);
      setCmpErrorMsz("Error: Missing required API values (stock name, expiry date, report type, or CMP).");
      setShowCmpApiError(true);
      setTimeout(() => {
      setShowCmpApiError(false);
      setCmpErrorMsz('');
      }, 2000);
    }
  
//      setOptionSectionState((prevState) => {
//        let newState
//        if (slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
//          newState = {
//            ...prevState,
//            [name]: value,
//            underlayingPrice: lastpricePresent? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
//            first_target: firstTargetPresent ? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
//            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
//            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
//            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
//            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
//            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
//          };
//        } else {
//          newState = {
//            ...prevState,
//            [name]: value,
//            underlayingPrice: lastpricePresent? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
//            first_target: firstTargetPresent ? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
//            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
//            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
//            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
//            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
//          };
//        }



//        onOptionSectionChange(newState);

//        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
//        let selectedRecord = null
//        for (let j = 0; j < tvRecord.length; j++) {
//          const record = tvRecord[j];

//          if (optionSectionState.optionReportType === "CALL") {
//            if (selectedRecord === null || record.low < selectedRecord.low) {
//              selectedRecord = record;
//            }
//          } else if (optionSectionState.optionReportType === "PUT") {
//            if (selectedRecord === null || record.high > selectedRecord.high) {
//              selectedRecord = record;
//            }
//          }
//       }
//        onStockLossRecord(selectedRecord);
//        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
//       return newState;
//      });
    } else { 
     setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,

        };


        onOptionSectionChange(newState);

        return newState;
      });
    }


  }





  // handle Clear StrikePrice data array
  const clearStrikePriceData = () => {
    setStrikePriceData([]);
  };

  // handle change for underlaying select
  const handleUnderlayingChange = async (event) => {
    const { name, value } = event.target;
    const indexOfMatchingValue = optionCmpData.findIndex((data) => data.last_price == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue underlaying change")
    if (indexOfMatchingValue !== -1) {
      console.log("value", typeof value, value)

    
      const strikePresent = strikePriceData[indexOfMatchingValue] && strikePriceData[indexOfMatchingValue].strike !== undefined;
     const firstTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].first_target !== undefined;
      const secondTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].second_target !== undefined;
      const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
      const volumePresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].volume !== undefined;
      const OIPresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].openInterest !== undefined;

      setOptionSectionState((prevState) => {
        let newState
        if (slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            first_target: firstTargetPresent ? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent ? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            first_target: firstTargetPresent ? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
          };
        }



        onOptionSectionChange(newState);

        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
        return newState;
      });
    } else {
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,

        };


        onOptionSectionChange(newState);

        return newState;
      });
    }
   
  }

  // handle change for first target select
  const handleFirstTargetChange = async (event) => {
    const { name, value } = event.target;
    const indexOfMatchingValue = optionCmpData.findIndex((data) => data.first_target == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue underlaying change")
    if (indexOfMatchingValue !== -1) {
      console.log("value", typeof value, value)

     
      const strikePresent = strikePriceData[indexOfMatchingValue] && strikePriceData[indexOfMatchingValue].strike !== undefined;
      const lastpricePresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].last_price !== undefined;
     const secondTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].second_target !== undefined;
      const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
      const volumePresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].volume !== undefined;
      const OIPresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].openInterest !== undefined;
      setOptionSectionState((prevState) => {
        let newState
        if (slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            second_target: secondTargetPresent ? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
          };
        }



        onOptionSectionChange(newState);

        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
        return newState;
      });
    } else {
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,

        };


        onOptionSectionChange(newState);

        return newState;
      });
    }

  }

// handle change for second target select
  const handleSecondTargetChange = async (event) => {
    const { name, value } = event.target;
    const indexOfMatchingValue = optionCmpData.findIndex((data) => data.second_target == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue underlaying change")
    if (indexOfMatchingValue !== -1) {
      console.log("value", typeof value, value)

     
      const strikePresent = strikePriceData[indexOfMatchingValue] && strikePriceData[indexOfMatchingValue].strike !== undefined;
      const lastpricePresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].last_price !== undefined;
      const firstTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].first_target !== undefined;
      const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
      const volumePresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].volume !== undefined;
      const OIPresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].openInterest !== undefined;
      setOptionSectionState((prevState) => {
        let newState
        if (slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
          };
        }



        onOptionSectionChange(newState);

        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
        return newState;
      });
    } else {
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,

        };


        onOptionSectionChange(newState);

        return newState;
      });
    }

  }

  // handle clear underlaying data array
  const clearUnderlayingPriceData = () => {
    let newArray = optionCmpData.map(({ last_price, ...rest }) => rest);
    setOptionCmpData(newArray);
    // setOptionCmpData([]);
  }
  // handle clear first target data array
  const clearFirstTargetData = () => {
    let newArray = optionCmpData.map(({ first_target, ...rest }) => rest);
    setOptionCmpData(newArray);
    console.log("new Array", newArray);
  }
  // handle clear second target data array
  const clearSecondTargetData = () => {
    let newArray = optionCmpData.map(({ second_target, ...rest }) => rest);
    setOptionCmpData(newArray);
  }

  // handle Stoploss change for select
  const handleStoplossChange = async (event) => {
    const { name, value } = event.target;

    const indexOfMatchingValue = stopLossData.findIndex((data) => data.OptionstopLoss == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue sl change")
    if (indexOfMatchingValue !== -1) {
      console.log("value")

    
      const strikePresent = strikePriceData[indexOfMatchingValue] && strikePriceData[indexOfMatchingValue].strike !== undefined;
      const lastpricePresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].last_price !== undefined;
      const firstTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].first_target !== undefined;
      const secondTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].second_target !== undefined;
      const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
      const volumePresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].volume !== undefined;
      const OIPresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].openInterest !== undefined;
      setOptionSectionState((prevState) => {
        let newState
        if (slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            volume:volumePresent ? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
          };
        }



        onOptionSectionChange(newState);
        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
        return newState;
      });
    } else {
      setOptionSectionState((prevState) => {

        let newState
        if (value == 0) {
          newState = {
            ...prevState,
            [name]: value,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
          };
        }

        onOptionSectionChange(newState);
        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);
        return newState;
      });
    }

  }

// handle clear stoploss data array
  const clearStoplossData = () => {
    let newArray = stopLossData.map(({ OptionstopLoss, ...rest }) => rest);
    setStopLossData(newArray);
  }

  // handle change for volume select
  const handleVolumeChange = async (event) => {
    const { name, value } = event.target;
    const indexOfMatchingValue = volumeData.findIndex((data) => data.volume == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue volume change")
    if (indexOfMatchingValue !== -1) {
      console.log("value")

   
      const strikePresent = strikePriceData[indexOfMatchingValue] && strikePriceData[indexOfMatchingValue].strike !== undefined;
      const lastpricePresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].last_price !== undefined;
      const firstTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].first_target !== undefined;
      const secondTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].second_target !== undefined;
      const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
     const OIPresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].openInterest !== undefined;
      setOptionSectionState((prevState) => {
        let newState
        if (slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            openInterest: OIPresent?volumeData[indexOfMatchingValue].openInterest:optionSectionState.openInterest,
          };
        }



        onOptionSectionChange(newState);
        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);

        return newState;
      });
    } else {
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
        };


        onOptionSectionChange(newState);

        return newState;
      });
    }

  }

  // handle change for open interest select
  const handleOpenInterestChange = async (event) => {
    const { name, value } = event.target;
    // console.log("event.target",event.target.name)
    // console.log("event.target",event.target.value)

    const indexOfMatchingValue = volumeData.findIndex((data) => data.openInterest == value);
    console.log(indexOfMatchingValue, "indexOfMatchingValue volume change")
    if (indexOfMatchingValue !== -1) {
      console.log("value")
    
      const strikePresent = strikePriceData[indexOfMatchingValue] && strikePriceData[indexOfMatchingValue].strike !== undefined;
      const lastpricePresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].last_price !== undefined;
      const firstTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].first_target !== undefined;
      const secondTargetPresent = optionCmpData[indexOfMatchingValue] && optionCmpData[indexOfMatchingValue].second_target !== undefined;
      const slPresent = stopLossData[indexOfMatchingValue] && stopLossData[indexOfMatchingValue].OptionstopLoss !== undefined;
      const volumePresent = volumeData[indexOfMatchingValue] && volumeData[indexOfMatchingValue].volume !== undefined;
      setOptionSectionState((prevState) => {
        let newState
        if ( slPresent && stopLossData[indexOfMatchingValue].OptionstopLoss == 0) {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume: volumePresent? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
            optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };
        } else {
          newState = {
            ...prevState,
            [name]: value,
            strikePrice: strikePresent? strikePriceData[indexOfMatchingValue].strike:optionSectionState.strikePrice,
            underlayingPrice: lastpricePresent ? optionCmpData[indexOfMatchingValue].last_price:optionSectionState.underlayingPrice,
            first_target: firstTargetPresent? optionCmpData[indexOfMatchingValue].first_target:optionSectionState.first_target,
            second_target: secondTargetPresent? optionCmpData[indexOfMatchingValue].second_target:optionSectionState.second_target,
            optionSL: slPresent? stopLossData[indexOfMatchingValue].OptionstopLoss:optionSectionState.optionSL,
            volume: volumePresent? volumeData[indexOfMatchingValue].volume:optionSectionState.volume,
          };
        }



        onOptionSectionChange(newState);
        let tvRecord = stopLossData[indexOfMatchingValue].tvRecord
        let selectedRecord = null
        for (let j = 0; j < tvRecord.length; j++) {
          const record = tvRecord[j];

          if (optionSectionState.optionReportType === "CALL") {
            if (selectedRecord === null || record.low < selectedRecord.low) {
              selectedRecord = record;
            }
          } else if (optionSectionState.optionReportType === "PUT") {
            if (selectedRecord === null || record.high > selectedRecord.high) {
              selectedRecord = record;
            }
          }
        }
        onStockLossRecord(selectedRecord);
        onOptionExpirySelect(strikePriceData[indexOfMatchingValue]);

        return newState;
      });
    } else {
      setOptionSectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
        };


        onOptionSectionChange(newState);

        return newState;
      });
    }

  }

  // handle clear volume data array
  const clearVolumeData = () => {
    let newArray = volumeData.map(({ volume, ...rest }) => rest);
    setVolumeData(newArray)
  }

  // handle clear open interest data array
  const clearOpenInterestData = () => {
    let newArray = volumeData.map(({ openInterest, ...rest }) => rest);
    setVolumeData(newArray)
  }

  


  return (
    <div className="optionmain">
      {loading ?
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}>
          <Loading />
        </div> : null}
      <div id="btnoptionDiv" className="btnoptiondiv">
        <p>CALL</p>
        <input type="radio" value="CALL" defaultChecked name="optionReportType" onChange={handleChange} />

        <p>PUT</p>
        <input type="radio" value="PUT" name="optionReportType" onChange={handleChange} />
      </div>

      <div id="option_content" className="optioncontent">
      <div>
          <p>Chart-Image Interval:</p>
          <select value={optionSectionState.chartImageInterval} id="chartImageInterval" name="chartImageInterval" onChange={handleChartinterval}>
  <option value="4h">4h</option>
  <option value="1D">1D</option>
  <option value="1W">1W</option>
  <option value="1M">1M</option>
  <option value="1Y">1Y</option>
</select>
        </div>
        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>
         

          <ReactSelect
            id="OptionStocktype"
            name="stockType"
            options={options}
            onChange={handlechangestock}
            styles={customStyles}
            disabled={!isEditable}
          />
        </div>

        {expiryshow ?
          <div style={{ marginTop: '16px' }}>
            <p>Expiry:<span className='asterisk'>*</span></p>
            <select id="optionexpiry" value={optionSectionState.Expiry} name="Expiry" required onChange={handlechangeExpiry} disabled={!isEditable}>
              <option value="">Select Expiry</option>
              {expiryData.map((expiry) => (
                <option key={expiry} value={expiry.expiry}>
                  {formatDate(expiry.expiry)}
                </option>
              ))}
            </select>
          </div>
          : null}

        {optioncmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{CmpErrorMsz}</span> : null}
        <div style={{ marginTop: '16px' }}>
          <p>UnderLying Price:<span className='asterisk'>*</span></p>
          <button class="fetch" style={{ cursor: optionSectionState.stockType == '' ? 'not-allowed' : 'pointer' }} disabled={optionSectionState.stockType == ''} onClick={fetchCMP}>Fetch</button>
          <input value={optionSectionState.optionCMP} type="number" id="optioncmp" name="optionCMP" required onChange={handleInputChange} disabled={!isEditable} />
        </div>

      
        {strikePriceerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showStrikePriceApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{StrikePriceErrorMsz}</span> : null}
        <div>
          <p>Strike Price:<span className='asterisk'>*</span></p>
       
          {strikePriceData.length > 0 ? (
            <>
              <select style={{ width: '49%' }} id="strikePrice" name="strikePrice" value={optionSectionState.strikePrice} onChange={handleStrikeChange} disabled={!isEditable}>
                <option value="">Select Strike Price</option>
                {strikePriceData.map((data) => (
                  <option key={data.instrument_token} value={data.strike}>
                    {data.strike}
                  </option>
                ))}
              </select>
              <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearStrikePriceData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>

            </>
          ) : (
            <input value={optionSectionState.strikePrice} type="number" id="strikePrice" name="strikePrice" required onChange={handleInputChange} disabled={!isEditable} />
          )}
        </div>


        {underlayingPriceerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        <div>
          <p>Option CMP:<span className='asterisk'>*</span></p>
         
          {optionCmpData.length > 0 && optionCmpData.every(data => data.last_price !== undefined)? (
            <>
              <select style={{ width: '49%' }} id="underlayingprice" name="underlayingPrice" value={optionSectionState.underlayingPrice} disabled={!isEditable}>
                <option value="">Select Option Cmp</option>
                {optionCmpData.map((data) => (
                  <option key={data.instrument_token} value={data.last_price}>
                    {data.last_price}
                  </option>
                ))}
              </select>
              <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearUnderlayingPriceData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
            </>
          ) : (
            <input value={optionSectionState.underlayingPrice} type="number" id="underlayingprice" name="underlayingPrice" required onChange={handleInputChange} disabled={!isEditable} />
          )}
        </div>



        {firstTargeterror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {IntraDaychecked ?
          <div>
            <p>First Target:<span className='asterisk'>*</span></p>
        

            {optionCmpData.length > 0 && optionCmpData.every(data => data.first_target !== undefined) ? (
              <>
                <select style={{ width: '49%' }} id="first_target" name="first_target" value={optionSectionState.first_target} onChange={handleFirstTargetChange} disabled={!isEditable}>
                  <option value="">Select First Target</option>
                  {optionCmpData.map((data) => (
                    <option key={data.instrument_token} value={data.first_target}>
                      {data.first_target}
                    </option>
                  ))}
                </select>
                <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearFirstTargetData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
              </>
            ) : (
              <input value={optionSectionState.first_target} type="number" id="first_target" name="first_target" required onChange={handleInputChange} disabled={!isEditable} />
            )}
          </div>
          : null}
        {secondTargeterror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {IntraDaychecked ?
          <div>
            <p>Second Target:<span className='asterisk'>*</span></p>
            
            {optionCmpData.length > 0 && optionCmpData.every(data => data.second_target !== undefined) ? (
              <>
                <select style={{ width: '49%' }} id="second_target" name="second_target" value={optionSectionState.second_target} onChange={handleSecondTargetChange} disabled={!isEditable}>
                  <option value="">Select Option Cmp</option>
                  {optionCmpData.map((data) => (
                    <option key={data.instrument_token} value={data.second_target}>
                      {data.second_target}
                    </option>
                  ))}
                </select>
                <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearSecondTargetData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
              </>
            ) : (
              <input value={optionSectionState.second_target} type="number" id="second_target" name="second_target" required onChange={handleInputChange} disabled={!isEditable} />
            )}
          </div>

          : null}


        {slerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        <div>

          <p>SL :<span className='asterisk'>*</span></p>
        

          {stopLossData.length > 0 && stopLossData.some(data => data.OptionstopLoss) ? (
            <>
              <select style={{ width: '49%' }} id="Optionsl" name="optionSL" value={optionSectionState.optionSL}  disabled={!isEditable}>
                <option value="">Select SL</option>
                {stopLossData.map((data, index) => (
                  <option key={index} value={data.OptionstopLoss}>
                    {data.OptionstopLoss}
                  </option>
                ))}
              </select>
              <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearStoplossData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
            </>
          ) : (
            <input value={optionSectionState.optionSL} type="number" id="Optionsl" name="optionSL" required onChange={handleInputChange} disabled={!isEditable} />

          )}  </div>
        {volumeError ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}

        <div>
          <p>Volume:</p>
          {volumeData.length > 0 && volumeData.some(data => data.volume) ? (
            <>
              <select style={{ width: '49%' }} id="volume" name="volume" value={optionSectionState.volume}  disabled={!isEditable}>
                <option value="">Select Volume</option>
                {volumeData.map((data, index) => (
                  <option key={index} value={data.volume}>
                    {data.volume}
                  </option>
                ))}
              </select>
              <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearVolumeData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
            </>
          ) : (
            <input value={optionSectionState.volume} type="number" id="volume" name="volume" required onChange={handleInputChange} disabled={!isEditable} />
          )}
        </div>


        <div>
          <p>Lot Size:</p>

          <input value={optionSectionState.lot_size} type="number" id="lot_size" name="lot_size" readOnly required />


        </div>

        <div>
          <p>Open Interest:</p>

         


          {volumeData.length > 0 && volumeData.some(data => data.openInterest) ? (
            <>
            <select style={{ width: '49%' }} id="openInterest" name="openInterest" value={optionSectionState.openInterest}  disabled={!isEditable}>
            <option value="">select open Interest</option>
            {volumeData.map((data, index) => (
              <option key={index} value={data.openInterest}>
                {data.openInterest}
              </option>
            ))}
          </select>
              <span style={{ cursor: 'pointer' }} className="clear-icon" onClick={clearOpenInterestData}><DriveFileRenameOutlineIcon style={{ color: 'red' }} /></span>
            </>
          ) : (
            <input value={optionSectionState.openInterest} type="number" id="openInterest" name="openInterest" required onChange={handleInputChange} disabled={!isEditable} />
          )}

        </div>


        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select id="selectcommentry" name="commentry" value={optionSectionState.commentry} onChange={handleOptionChange} disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
              <option key={data.CommentaryName} value={data.Description}>
                {data.CommentaryName}
              </option>
            ))}
          </select>
         
        </div>


        <div>
          <p>Commentary Remarks:</p>
          <textarea style={{
            border: `2px solid ${optionSectionState.optionSL == '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
            outline: 'none',
          }} value={optionSectionState.optionRemark} id="optionremark" name="optionRemark" required rows={4} onChange={handleChange} disabled={!isEditable} />
        </div>

       
      </div>

         <Dialog
                          open={showAlert}
                          onClose={() => { setshowAlert(false) }}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
                        </Dialog>
    </div>
  );
};

export default OptionSection;
